import bigJson from 'big-json'

var hasProp = Object.prototype.hasOwnProperty

const throwsMessage = err => `[Throws: ${err ? err.message : '?'}]`

const safeGetValueFromPropertyOnObject = (obj, property) => {
  if (hasProp.call(obj, property)) {
    try {
      return obj[property]
    } catch (err) {
      return throwsMessage(err)
    }
  }

  return obj[property]
}

export const ensureProperties = payload => {
  const seen = [] // store references to objects we have seen before

  const visit = obj => {
    if (typeof obj === 'function') {
      return obj.name ? `[Function:${obj.name}]` : '[Function]'
    }

    if (obj === null || typeof obj !== 'object') {
      return obj
    }

    if (seen.indexOf(obj) !== -1) {
      return '[Circular]'
    }
    seen.push(obj)

    if (typeof obj.toJSON === 'function') {
      try {
        const fResult = visit(obj.toJSON())
        seen.pop()
        return fResult
      } catch (err) {
        return throwsMessage(err)
      }
    }

    if (Array.isArray(obj)) {
      const aResult = obj.map(visit)
      seen.pop()
      return aResult
    }

    const result = {}
    for (let prop in obj) {
      // prevent faulty defined getter properties
      result[prop] = visit(safeGetValueFromPropertyOnObject(obj, prop))
    }
    seen.pop()
    return result
  }

  return visit(payload)
}

export const safeStringify = (data, replacer, space) =>
  JSON.stringify(ensureProperties(data), replacer, space)

export default safeStringify
